import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import UPDataTableMappingDefaults from 'client/components/UPDataTableMappingDefaults/UPDataTableMappingDefaults';
import UPCreateMappingDefaultFormModal from 'client/components/UPCreateMappingDefaultForm/UPCreateMappingDefaultFormModal';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrBox from 'client/components/SrBox';

const UPDataTableMappingDefaultsCollapsible = ({ collapsed, title, utilityTypes }) => {
  const [isCollapsed, setIsCollapsed] = useState(!!collapsed);
  const [isCreateMappingDefaultModalOpen, setIsCreateMappingDefaultModalOpen] = useState(false);
  const toggleCollapsed = () => setIsCollapsed(!isCollapsed);

  return (
    <div style={{ marginBottom: '15px' }}>
      <SrFlex columnGap="10px">
        <SrText
          font="greycliff"
          size="16"
          weight="500"
          color="blue300"
          onClick={() => {
            setIsCreateMappingDefaultModalOpen(true);
          }}
          cursor="pointer"
          display="block"
        >
          Create Mapping Default
        </SrText>
        <SrText
          font="greycliff"
          size="16"
          weight="500"
          color="blue300"
          onClick={toggleCollapsed}
          cursor="pointer"
          display="block"
        >
          {isCollapsed ? 'Open Mapping Defaults' : 'Close Mapping Defaults'}
        </SrText>
      </SrFlex>

      {!isCollapsed && (
        <SrDarkModal onClose={toggleCollapsed}>
          <SrModalContent onCloseIconClick={toggleCollapsed}>
            {title && (
              <SrBox marginBottom="16px">
                <SrText padding="10px 0" font="greycliff" size="28" weight="800" display="block">
                  {title}
                </SrText>
              </SrBox>
            )}
            <UPDataTableMappingDefaults utilityTypes={utilityTypes} />
          </SrModalContent>
        </SrDarkModal>
      )}
      {isCreateMappingDefaultModalOpen && (
        <UPCreateMappingDefaultFormModal
          title="Add Mapping Default"
          afterSubmit={() => {
            setIsCreateMappingDefaultModalOpen(false);
            global.location.reload();
          }}
          onClose={() => setIsCreateMappingDefaultModalOpen(false)}
        />
      )}
    </div>
  );
};

UPDataTableMappingDefaultsCollapsible.propTypes = {
  collapsed: PropTypes.bool,
  title: PropTypes.string,
  utilityTypes: PropTypes.array,
};

export default UPDataTableMappingDefaultsCollapsible;
